import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { State } from '@auth/store';
import { Login } from '@auth/store/actions/auth.actions';
import { selectLoginError, selectLoginLoading } from '@auth/store/selectors/login.selectors';
import { AuthCredentials, AuthCredentialsForm } from '@auth/interfaces/auth-credentials.interface';
import { Observable } from 'rxjs';
import { selectAuthProfileError } from '@auth/store/selectors/profile.selectors';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-auth-login',
  templateUrl: './auth-login.component.html',
  styleUrls: ['./auth-login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AuthLoginComponent {
  private readonly store = inject<Store<State>>(Store);

  public readonly error$: Observable<Error | null>;
  public readonly profileError$: Observable<Error | null>;
  public readonly loading$: Observable<boolean>;
  public loginFormGroup: FormGroup<AuthCredentialsForm> = new FormGroup<AuthCredentialsForm>({
    email: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    password: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
  });
  public showPassword = false;
  public passFieldType: 'text' | 'password' = 'password';

  get environmentName(): string {
    return environment.name === 'sb' || environment.name === 'dev' ? environment.name : '';
  }

  constructor() {
    this.error$ = this.store.select(selectLoginError);
    this.profileError$ = this.store.select(selectAuthProfileError);
    this.loading$ = this.store.select(selectLoginLoading);
  }

  public submit(): void {
    if (this.loginFormGroup.invalid) {
      return;
    }
    const values = this.loginFormGroup.value;
    const credentials: AuthCredentials = {
      email: values.email || '',
      password: values.password || '',
    };
    this.store.dispatch(Login({ credentials }));
  }

  public toggleShowPass(): void {
    this.passFieldType = this.passFieldType === 'password' ? 'text' : 'password';
    this.showPassword = !this.showPassword;
  }
}
